import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SessionService } from '../services/session.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const session = inject(SessionService);

  // Ao entrar por URL direta, sincroniza o signal com o que estiver persistido.
  session.restoreSession();

  if (session.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
